'use client';

import { MAP_SIZE } from '@/constants/mapConstants';
import useMap from '@/hooks/useMap';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export default function ShowIfMapExpanded({ children }: Props): JSX.Element | null {
  const { mapView } = useMap();
  if (mapView === MAP_SIZE.MEDIUM) {
    return <>{children}</>;
  }
  return null;
}
